export const getXAxis = () => {
	const width = document.body.clientWidth
	let is_w = width / 1920;is_w=is_w>1?1:is_w
	return {
		data: getLastSevenDays(),
		axisLabel: {
			margin: 20,
			style: {

				textBaseline: 'top',

				fill: '#cdcac3',
				fontSize: 16 * is_w
			},
			formatter: function (value, index) {

				let date =new Date(value.value)
				return date.getMonth()+1+'/'+date.getDate()
			}
		},
		axisLine: {
			style: {
				stroke: '#cdcac3',
				lineWidth: 1,
				fontSize: is_w * 20
			}
		},
		nameTextStyle: {
			fill: '#fff',
			fontSize: is_w * 20
		},
		axisTick: {
			style: {
				stroke: '#cdcac3',
				lineWidth: 1,
				fontSize: is_w * 20
			}
		}
	}
}

function getLastSevenDays() {
	const dates = [];
	const today = new Date();

	for (let i = 6; i >= 0; i--) {
		const pastDate = new Date();
		pastDate.setDate(today.getDate() - i);
		dates.push(pastDate.toISOString().split('T')[0]); // 格式化为 YYYY-MM-DD
	}

	return dates;
}
